<template>
  <div class="dtlProgress">
    <button
      class="btn btn-danger btn-sm float-start my-3 mx-2"
      type="button"
      data-bs-toggle="modal"
      data-bs-target="#timeabsenpulang"
      @click.prevent="showModalsBs('', 'tambah')"
    >
      Tambah Data
    </button>
    <br />
    <div class="col-12 py-5">
      <div class="list-group">
        <div v-for="item in dataView" :key="item.autono" class="py-1 px-2">
          <a class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">{{ item.judul }}</h5>
              <div class="d-flex w-50 justify-content-end">
                <button
                  class="btn btn-warning btn-sm float-end mx-2"
                  type="button"
                  @click.prevent="showModalsBs(item.autono, 'edit')"
                >
                  Ubah Data
                </button>
                <button
                  class="btn btn-danger btn-sm float-end"
                  type="button"
                  @click.prevent="hapus(item.autono)"
                >
                  Hapus
                </button>
              </div>
            </div>
            <p class="mb-0">Progres : {{ item.progres }}</p>
            <p class="mb-0">Biaya : {{ item.biaya }}</p>
            <p class="mb-0">Tanggal Upload : {{ item.tanggal_upload }}</p>
            <p class="mb-0">Ket : {{ item.keterangan }}</p>
          </a>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="timeabsenpulang"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="timeabsenpulangLabel"
      aria-hidden="true"
      :class="{ 'show d-block mt-0 px-0': showModals, '': !showModals }"
      v-bind:style="showModals ? 'background-color: #0000009c' : ''"
      v-bind:role="showModals ? 'dialog' : ''"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="timeabsenpulangLabel">
              {{ labelButton }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click.prevent="hideModalsBs()"
            ></button>
          </div>
          <div class="overlay" v-show="loadingProg == true">
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <form @submit.prevent="updateData(status)" ref="fEditable">
              <dl class="row g-2 py-3">
                <dt>Tanggal :</dt>
                <dd>
                  <input
                    type="date"
                    class="form-control"
                    v-model="tanggal"
                    required
                    :readonly="readonly"
                    :min="lastTglUpload"
                  />
                </dd>
                <dt>Judul Kegiatan :</dt>
                <dd>
                  <input
                    type="text"
                    class="form-control"
                    v-model="judul"
                    required
                  />
                </dd>
                <dt>Tipe Dokumen</dt>
                <select class="form-control" v-model="selectedDokumen" required>
                  <option disabled>Pilih Tipe Dokumen</option>
                  <option
                    v-for="dok in listTipeDokumen"
                    :key="dok.autocode"
                    :value="dok.autocode"
                  >
                    {{ dok.nama_dokumen }}
                  </option>
                </select>
                <dt>Upload File :</dt>
                <input
                  type="file"
                  ref="file"
                  multiple
                  class="form-control"
                  accept="image/*"
                  @change="onChange"
                />
                <small>format file : <code>jpg, png, jpeg</code> (Multiple file allowed)</small>
                <dd v-if="imagePreviews.length > 0" class="mt-3">
                  <div class="row g-2">
                    <div 
                      v-for="(preview, index) in imagePreviews" 
                      :key="index" 
                      class="col-6 col-md-4"
                    >
                      <div class="card position-relative">
                        <button 
                          type="button"
                          class="btn btn-danger btn-sm position-absolute top-0 end-0 m-1"
                          style="z-index: 10; padding: 0.25rem 0.5rem;"
                          @click.prevent="removeFile(index)"
                        >
                          ×
                        </button>
                        <div class="card-body p-2">
                          <img 
                            :src="preview.url" 
                            class="img-fluid rounded" 
                            style="width: 100%; height: 150px; object-fit: cover;"
                            :alt="preview.name"
                          />
                          <small class="d-block text-truncate mt-1">{{ preview.name }}</small>
                          <small class="d-block text-muted">{{ preview.size }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </dd>
                <dt>Progres Seluruh Kegiatan (%) :</dt>
                <dd>
                  <input
                    type="number"
                    class="form-control"
                    v-model="progres"
                    max="100"
                    :min="lastProgres"
                    :readonly="readonly"
                    required
                  />
                </dd>
                <dt>Biaya :</dt>
                <dd>
                  <input
                    type="text"
                    class="form-control"
                    v-model="biaya"
                    required
                  />
                </dd>
                <dt>Keterangan :</dt>
                <dd>
                  <textarea
                    class="form-control"
                    v-model="keterangan"
                  ></textarea>
                </dd>
              </dl>
              <button type="submit" class="btn btn-primary mt-1 btn-block">
                Simpan
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import imageCompressor from "./Compressor/vue-image-compressor.vue";
const axios = require("axios");
const Swal = require("sweetalert2");
const headers = {
  "Content-Type": "multipart/form-data",
  Authorization: "Bearer " + sessionStorage.getItem("key"),
};

export default {
  data() {
    return {
      uppercase: atob(this.$route.query.q),
      ptp: atob(this.$route.query.r),
      autono: atob(this.$route.query.s),
      dataView: [],
      editView: [],
      empty: true,
      editKegiatan: this.$el,
      id_report: "",
      tanggal: "",
      judul: "",
      progres: 0,
      biaya: 0,
      keterangan: "",
      readonly: false,
      status: "",
      file: "",
      listTipeDokumen: [],
      selectedDokumen: {},
      lastProgres: 0,
      lastTglUpload: "",
      labelButton: "Tambah Data",
      loadingProg: false,
      base64: null,
      filename: null,
      mimetype: null,
      ukuran: null,
      compressed: {},
      original: {},
      result: {},
      reader: {},
      multipleFiles: [],
      imagePreviews: [],
      showModals: false,
    };
  },
  // components: {
  //   imageCompressor,
  // },
  methods: {
    showModalsBs(autono, status) {
      console.log(this.uppercase);
      this.showModals = true;

      if (status == "tambah") {
        this.labelButton = "Tambah Data";
        this.$refs.fEditable.reset();
        this.readonly = false;
        this.status = "tambah";
        this.lastData();
        // Clear files when opening add modal
        this.multipleFiles = [];
        this.imagePreviews = [];
      } else {
        this.readonly = true;
        this.status = "edit";
        this.labelButton = "Ubah Data ?";
        try {
          axios
            .post(
              this.UrlApi + "listaktproyek/edit",
              {
                id: autono,
              },
              { headers: headers }
            )
            .then((res) => {
              if (res.data.result !== null) {
                this.empty = res.data.result.length > 0 ? false : true;
                this.id_report = res.data.result.autono;
                this.tanggal = res.data.result.tanggal_upload;
                this.judul = res.data.result.judul;
                this.progres = res.data.result.progres;
                this.biaya = res.data.result.biaya;
                this.keterangan = res.data.result.keterangan;
                this.selectedDokumen = res.data.result.id_tipe_dokumen;
              } else {
                this.empty = true;
                Swal.fire({
                  icon: "error",
                  title: "Gagal!",
                  text: "",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            })
            .catch((err) => {
              if (err.response) {
                console.log("error response");
              } else if (err.request) {
                console.log("error request");
              } else {
                console.log("error");
              }
              this.empty = true;
            });
        } catch (error) {
          console.log(error);
        }
      }
    },
    hideModalsBs() {
      this.showModals = false;
      // Clear uploaded files when modal is closed
      this.multipleFiles = [];
      this.imagePreviews = [];
      window.location.reload();
    },
    updateData(status) {
      if (status == "tambah") {
        this.loadingProg = true;
        try {
          // Prepare data - send multiple files if available, otherwise single file
          const dataToSend = {
            tanggal_upload: this.tanggal,
            progres: this.progres,
            judul: this.judul,
            biaya: this.biaya,
            keterangan: this.keterangan,
            username: localStorage.getItem("nama"),
            id_aktifitas_proyek: this.uppercase,
            id_penetapan_proyek: this.ptp,
            id_tipe_dokumen: this.selectedDokumen,
          };

          // If multiple files exist, send as array
          if (this.multipleFiles.length > 0) {
            dataToSend.files = this.multipleFiles.map(f => ({
              file: f.base64,
              filename: f.name,
              mimetype: f.type,
              size: f.size,
            }));
          } else {
            // Backward compatibility - single file
            dataToSend.file = this.compressed;
            dataToSend.filename = this.filename;
            dataToSend.mimetype = this.mimetype;
            dataToSend.size = this.ukuran;
          }

          axios
            .post(
              this.UrlApi + "listaktproyek/savebase",
              dataToSend,
              { headers: headers }
            )
            .then((res) => {
              // console.log(res);
              if (res.data.result !== null) {
                this.loadingProg = false;
                Swal.fire({
                  icon: "success",
                  title: "Berhasil!",
                  text: "Data berhasil disimpan",
                  showConfirmButton: false,
                  timer: 1500,
                });
                window.location.reload();
              } else {
                this.loadingProg = false;
                this.empty = true;
                Swal.fire({
                  icon: "error",
                  title: "Gagal!",
                  text: "",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            })
            .catch((err) => {
              if (err.response) {
                console.log(err.response);
                this.loadingProg = false;
              } else if (err.request) {
                console.log(err.request);
                this.loadingProg = false;
              } else {
                console.log("error");
                this.loadingProg = false;
              }
              this.empty = true;
            });
        } catch (error) {
          console.log(error);
          this.loadingProg = false;
          Swal.fire({
            icon: "error",
            title: "Gagal!",
            text: "",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } else {
        this.loadingProg = true;
        try {
          axios
            .post(
              this.UrlApi + "listaktproyek/update",
              {
                id: this.id_report,
                judul: this.judul,
                biaya: this.biaya,
                keterangan: this.keterangan,
              },
              { headers: headers }
            )
            .then((res) => {
              if (res.data.result !== null) {
                this.loadingProg = false;
                window.location.reload();
              } else {
                this.loadingProg = false;
                this.empty = true;
                Swal.fire({
                  icon: "error",
                  title: "Gagal!",
                  text: "",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            })
            .catch((err) => {
              if (err.response) {
                console.log("error response");
                this.loadingProg = false;
                Swal.fire({
                  icon: "error",
                  title: "Gagal!",
                  text: "",
                  showConfirmButton: false,
                  timer: 1500,
                });
              } else if (err.request) {
                console.log("error request");
                this.loadingProg = false;
                Swal.fire({
                  icon: "error",
                  title: "Gagal!",
                  text: "Ukuran gambar tidak boleh lebih dari 1 Mb",
                  showConfirmButton: false,
                  timer: 1500,
                });
              } else {
                console.log("error");
                this.loadingProg = false;
                Swal.fire({
                  icon: "error",
                  title: "Gagal!",
                  text: "",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
              this.empty = true;
            });
        } catch (error) {
          console.log(error);
          this.loadingProg = false;
          Swal.fire({
            icon: "error",
            title: "Gagal!",
            text: "",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    },
    hapus(autono) {
      try {
        axios
          .post(
            this.UrlApi + "listaktproyek/hapus",
            {
              id: autono,
            },
            { headers: headers }
          )
          .then((res) => {
            if (res.data.result !== null) {
              window.location.reload();
            } else {
              this.empty = true;
              Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: "",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
            this.empty = true;
          });
      } catch (error) {
        console.log(error);
      }
    },
    // onChnageFileUpload() {
    //   this.file = this.$refs.file.files[0];
    //   this.ukuran = this.$refs.file.files[0].size;
    //   this.filename = this.$refs.file.files[0].name;
    //   this.mimetype = this.$refs.file.files[0].type;
    //   // this.createBase64Image(this.file);
    //   console.log(this.file);
    // },
    upload() {
      let compressor = this.$refs.compressor.$el;
      compressor.click();
    },
    createBase64Image(FileObject) {
      const reader = new FileReader();
      reader.onload = (event) => {
        var img64 = event.target.result;
        var splited = img64.split(",");
        this.base64 = splited[1];
      };
      reader.readAsDataURL(FileObject);
    },
    getFiles(obj) {
      // console.log("get files");
      this.file = obj.compressed;
      this.original = obj.original;
      // const b = a.size.replace("kB", " ");
      // this.original = parseInt(b);
      this.compressed = obj.compressed.base64;
      this.mimetype = obj.compressed.type;
      this.filename = obj.compressed.name;
      this.ukuran = obj.compressed.file.size;
      // console.log(this.compressed);
      // this.quality = 50;
      // console.log(parseInt(b));
    },
    lastData() {
      try {
        axios
          .post(
            this.UrlApi + "lastdataaktifitas",
            {
              parent_id: this.uppercase,
            },
            { headers: headers }
          )
          .then((res) => {
            if (res.data.result !== null) {
              this.lastProgres = res.data[0].progres;
              this.lastTglUpload = res.data[0].tanggal_upload;
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
            this.empty = true;
          });
      } catch (error) {
        console.log(error);
      }
    },
    //proses compress

    //jika input file berubah
    onChange(e) {
      const selectedFiles = e.target.files;
      
      // Jika tidak ada file yang dipilih
      if (!selectedFiles || selectedFiles.length === 0) return false;

      // Process each selected file
      Array.from(selectedFiles).forEach((file) => {
        // Validasi tidak boleh selain gambar
        let type = file.type;
        let valid = type.indexOf("image") !== -1;

        if (!valid) {
          Swal.fire({
            icon: "error",
            title: "Gagal!",
            text: "Format file harus jpg, png, dan jpeg",
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }

        // Buat FileReader untuk file ini
        const reader = new FileReader();

        // Convert file ke base64 text
        reader.readAsDataURL(file);

        // On reader load
        reader.onload = () => {
          // Buat fileInfo Object
          let fileInfo = {
            name: file.name,
            type: file.type,
            size: Math.round(file.size / 1000) + " kB",
            base64: reader.result,
            file: file,
          };

          // Compress and add to array
          this.compressAndAddImage(fileInfo);
        };
      });

      // Reset input value
      e.target.value = '';
    },

    // Compress and add image to array
    compressAndAddImage(fileInfo) {
      // Create canvas element
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");

      // Create new image
      let img = new Image();
      img.onload = () => {
        // Image size after scaling
        let scale = 45 / 100;
        let width = img.width * scale;
        let height = img.height * scale;

        // Set canvas dimensions
        canvas.setAttribute("width", width);
        canvas.setAttribute("height", height);

        ctx.drawImage(img, 0, 0, width, height);

        // Quality of image
        let quality = 45 / 100;

        // Get compressed base64
        let base64 = canvas.toDataURL(fileInfo.type, quality);
        let splitedType = fileInfo.type.split("/");
        let fileName = fileInfo.file.name;
        let lastDot = fileName.lastIndexOf(".");
        fileName = fileName.substr(0, lastDot) + "." + splitedType[1];

        let compressedFile = this.buildFile(base64, fileName);
        let compressedSize = Math.round(compressedFile.size / 1000) + " kB";

        // Add to multipleFiles array
        this.multipleFiles.push({
          base64: base64,
          name: fileName,
          type: fileInfo.type,
          size: compressedFile.size,
          file: compressedFile,
        });

        // Add preview
        this.imagePreviews.push({
          url: base64,
          name: fileName,
          size: compressedSize,
        });

        // Update single file properties for backward compatibility (use first file)
        if (this.multipleFiles.length === 1) {
          this.compressed = base64;
          this.mimetype = fileInfo.type;
          this.filename = fileName;
          this.ukuran = compressedFile.size;
        }
      };

      img.src = fileInfo.base64;
    },

    // Remove file from array
    removeFile(index) {
      this.multipleFiles.splice(index, 1);
      this.imagePreviews.splice(index, 1);

      // Update single file properties if files still exist
      if (this.multipleFiles.length > 0) {
        this.compressed = this.multipleFiles[0].base64;
        this.mimetype = this.multipleFiles[0].type;
        this.filename = this.multipleFiles[0].name;
        this.ukuran = this.multipleFiles[0].size;
      } else {
        this.compressed = {};
        this.mimetype = null;
        this.filename = null;
        this.ukuran = null;
      }
    },

    //ketika file sudah dimuat sepenuhnya
    fileOnLoad() {
      let { file } = this;

      // buat fileInfo Object
      let fileInfo = {
        name: file.name,
        type: file.type,
        size: Math.round(file.size / 1000) + " kB",
        base64: this.reader.result,
        file: file,
      };

      this.result = fileInfo;
      // DrawImage
      this.drawImage(this.result.base64);
    },

    // Draw and compress the image
    drawImage(imgUrl) {
      // Recreate canvas element
      let canvas = document.createElement("canvas");

      //set canvas context
      let ctx = canvas.getContext("2d");

      // Create new image
      let img = new Image();
      img.onload = () => {
        // console.log(img.width, img.height);
        // Image size after sacling
        let scale = 45 / 100;
        let width = img.width * scale;
        let height = img.height * scale;
        // set canvas height and width berdasarkan ukuran dan scale gambar
        canvas.setAttribute("width", width);
        canvas.setAttribute("height", height);

        ctx.drawImage(img, 0, 0, width, height);

        // Quality of image
        let quality = 45 / 100;

        // jika file sudah di proses
        let base64 = canvas.toDataURL(this.file.type, quality);
        let splitedType = this.file.type.split("/");
        let fileName = this.result.file.name;
        let lastDot = fileName.lastIndexOf(".");
        fileName = fileName.substr(0, lastDot) + "." + splitedType[1];

        let objToPass = {
          canvas: canvas,
          original: this.result,
          compressed: {
            // blob: this.toBlob(base64),
            base64: base64,
            name: fileName,
            file: this.buildFile(base64, fileName),
          },
        };

        objToPass.compressed.size =
          Math.round(objToPass.compressed.file.size / 1000) + " kB";
        objToPass.compressed.type = this.file.type;
        // console.log("done", objToPass.compressed);

        this.compressed = objToPass.compressed.base64;
        this.mimetype = objToPass.compressed.type;
        this.filename = objToPass.compressed.name;
        this.ukuran = objToPass.compressed.file.size;
      };

      img.src = imgUrl;
    },
    //convert base64 to file
    buildFile(base64, name) {
      // Convert base64 to blob
      const arr = base64.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const blob = new Blob([u8arr], { type: mime });
      
      // Convert blob to file
      return new File([blob], name, { type: mime });
    },
  },
  created() {
    try {
      axios
        .post(
          this.UrlApi + "listaktproyek/detil",
          {
            autocode: this.uppercase,
          },
          { headers: headers }
        )
        .then((res) => {
          // console.log(res.data.result.data);
          if (res.data.result !== null) {
            this.empty = res.data.result.data.length > 0 ? false : true;
            this.dataView = res.data.result.data;
          } else {
            this.empty = true;
            Swal.fire({
              icon: "error",
              title: "Gagal!",
              text: "",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("error response");
          } else if (err.request) {
            console.log("error request");
          } else {
            console.log("error");
          }
          this.empty = true;
        });
    } catch (error) {
      console.log(error);
    }

    try {
      axios
        .get(this.UrlApi + "tipedokumen", { headers: headers })
        .then((res) => {
          this.listTipeDokumen = res.data.result;
        })
        .catch((err) => {
          if (err.response) {
            console.log("error response");
          } else if (err.request) {
            console.log("error request");
          } else {
            console.log("error");
          }
          this.empty = true;
        });
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
